var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"logo-text"},[_c('span',[_vm._v("Na rzecz dobrego")]),_c('span',[_vm._v("druku i sprawnej")]),_c('span',[_vm._v("produkcji")])])}]

export { render, staticRenderFns }